/* eslint-disable import/prefer-default-export */
export const SUBSYSTEM_NAMES: { [sigla: string]: string } = {
  SIN: 'Sistema Interligado Nacional',
  SUDESTE: 'Sudeste / Centro-Oeste',
  SUL: 'Sul',
  NORDESTE: 'Nordeste',
  NORTE: 'Norte',
};
